import Scene = Phaser.Scene;
import Text = Phaser.GameObjects.Text;
import {Artifact, EffectType} from "@/store/artifact/types";
import {Keys} from "@/constants/key";
import TextUtils from "@/utils/text-utils";
import TimeUtils from "@/utils/time-utils";
import {Fonts} from "@/constants/font";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";
import {CreatureUtils} from "@/utils/creature-utils";
import {ForceWithUpgrade} from "@/store/force/types";
import {WarriorClass} from "@/store/level/types";
import PlayerStore from "@/store/player";

export enum UnlockState { UNLOCKED, LOCKED, CAN_UNLOCK }

export class ForceSlot extends Phaser.GameObjects.Container {

    private clickCallback: (() => unknown) | undefined;

    private timeText: Text | undefined;
    private readonly force: ForceWithUpgrade | undefined;
    private size: number;

    constructor(scene: Scene, x: number, y: number, size: number, force: ForceWithUpgrade, clickCallback: () => unknown) {
        super(scene);
        this.clickCallback = clickCallback;

        this.scene = scene;
        this.x = x;
        this.y = y;
        this.force = force;
        this.size = size;

        this.setScale(0.95 / CU.S);

        const slotImage = SpriteUtils.addImage(this.scene, 0, 0,
            CreatureUtils.getForceAtlasLarge(force.warriorClass), CreatureUtils.getLargeForceIcon(force.warriorClass, true))
            .setOrigin(0.5, 0.5).setInteractive();
        SpriteUtils.setDispSize(slotImage, size * CU.S , size * CU.S);

        slotImage.on('pointerdown', () => {
        });
        slotImage.on('pointerup', () => {
            clickCallback();
        });

        this.add(slotImage);

        if(!force || force && force.level == 0){
            const slotCover = SpriteUtils.addImage(this.scene, 0, 0, Keys.ATLAS_UI_FORCES, Keys.UI_FORCES_BLACK_BG)
                .setOrigin(0.5, 0.5);
            slotCover.setAlpha(0.5);
            SpriteUtils.setDispSize(slotCover, size * CU.S * 0.95, size *  CU.S * 0.95);
            this.add(slotCover);

            const slotCover2 = SpriteUtils.addImage(this.scene, 0, 0, Keys.ATLAS_UI_FORCES, Keys.UI_FORCES_GLASS_BG)
                .setOrigin(0.5, 0.5);
            slotCover2.setAlpha(1);
            SpriteUtils.setDispSize(slotCover2, size * CU.S * 0.90, size *  CU.S * 0.90);
            this.add(slotCover2);
        }

        if (!force) {
            return;
        }

        let isStillUpgrading = !!force.updatingTill && force.updatingTill > TimeUtils.getServerTimeMs();

        let scale = 1.4;

        let player = PlayerStore.getPlayer()
        const upgradeIcon = SpriteUtils.addImage(this.scene,
            -41, 43, //0,56,
            Keys.ATLAS_UI_FORCES,
            isStillUpgrading ? Keys.UI_FORCES_INDICATOR_UPGRADE_IN_PROGRESS : Keys.UI_FORCES_INDICATOR_CAN_UPGRADE, scale ,scale).setOrigin(0.5, 0.5);
        upgradeIcon.setVisible((isStillUpgrading || (force.canUpgrade && force.minLevelMonster <= player.bestVictoryStair) && force.level > 0));

        let rankImage = Keys.UI_FORCES_INDICATOR_BG;
        if(force && force.level == 0 && force.canUpgrade){
            rankImage = Keys.UI_FORCES_INDICATOR_AVAILABLE;
        } else if (!force || (force.level == 0 && !force.canUpgrade)){
            rankImage = Keys.UI_FORCES_INDICATOR_UNAVAILABLE;
        }

        const rankBg = SpriteUtils.addImage(this.scene,
            ForceSlot.getEffectIconPosX() ,
            ForceSlot.getEffectIconPosY(),
            Keys.ATLAS_UI_FORCES, rankImage, scale, scale).setOrigin(0.5, 0.5);

        let rankNumber = TextUtils.addTextByFamily(scene, force.level.toString(),
            (ForceSlot.getEffectIconPosX() + 1) , (ForceSlot.getEffectIconPosY() + 2),
            '#daba6f', 17, 'bold', 450, Fonts.BENGALY_NORMAL).setOrigin(0.5, 0.5);

        rankBg.setVisible(force.level != 1 ||  force.canUpgrade);
        rankNumber.setVisible(force.level > 1 || (force.level == 1 &&  force.canUpgrade));

        this.add([rankBg, rankNumber, upgradeIcon]);
    }

    public refreshTimer(): boolean {
        if (this.force && this.force.updatingTill && this.force.updatingTill > 0) {
            const remainSec = Math.floor((this.force.updatingTill - TimeUtils.getServerTimeMs()) / 1000);
            if (this.timeText) {
                this.timeText.setText(TimeUtils.getDurationText(Math.max(remainSec, 0)));
            } else {
                this.timeText = TextUtils.addTextByFamily(this.scene, TimeUtils.getDurationText(remainSec),
                    0, 10, '#ffffff', 11 / CU.S, 'bold', 100, Fonts.MYRIADPRO_BOLD).setOrigin(0.5, 0.5);
                this.add(this.timeText);
            }
            return remainSec < 0;
        }
        return false;
    }

    public emulateClick() {
        this.clickCallback!()
    }

    private static getEffectIconPosX(): number {
        return 41;
    }

    private static getEffectIconPosY(): number {
        return 43;
    }

    public setOrigin(x: number, y: number): void {
        // do nothing
    }

}
